import { onKeyStroke } from '@vueuse/core'

const isInteractiveTarget = (target: HTMLElement): boolean =>
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement ||
    target instanceof HTMLButtonElement ||
    target instanceof HTMLAnchorElement ||
    target.isContentEditable ||
    !!target.closest('[contenteditable="true"]') ||
    !!target.closest('button,[role="button"],a,select')

export function useEnterToProceed(proceed: () => unknown, isEnabled: () => boolean = () => true) {
    onKeyStroke('Enter', (event) => {
        if (!isEnabled()) return

        const target = event.target as HTMLElement | null
        if (!target) return

        if (target.closest('[role="dialog"], [aria-modal="true"]')) return

        // Avoid triggering navigation while the user is interacting with controls/actions.
        if (isInteractiveTarget(target)) return

        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return

        proceed()
    })
}
